module.exports = __webpack_public_path__ + "images/icons_v2/arrow-down-54bc4acc.svg";